import { QpPasswordService } from '@library/classes/qp-password/qp-password.service';
import { SERVER_API_URL } from '@one/app/app.constants';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PasswordService implements QpPasswordService {
  public readonly _httpClient = inject(HttpClient);

  public getSecurityScore$(password: Readonly<string>): Observable<unknown> {
    return this._httpClient.post(`${SERVER_API_URL}/api/passwords/score`, { password });
  }

  public getPasswordRules$(): Observable<unknown> {
    return this._httpClient.get(`${SERVER_API_URL}/api/passwords/rules`, { observe: 'body' });
  }
}
